import { ReactNode } from 'react'
import { useAuth } from '../auth/AuthProvider'
import { isCemEmployee } from '../auth/isCemEmployee'
import { setTokenGetter } from '../api/api'
import { Spinner, Stack, SpinnerSize } from '@fluentui/react'
import Unauthorized from './Unauthorized'

type ProtectedRouteProps = {
  children: ReactNode
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, login, getAccessToken, user } = useAuth()

  if (isLoading) {
    return (
      <Stack verticalAlign="center" horizontalAlign="center" styles={{ root: { height: '100vh' } }}>
        <Spinner size={SpinnerSize.large} label="Loading..." />
      </Stack>
    )
  }

  if (!isAuthenticated) {
    login()
    return (
      <Stack verticalAlign="center" horizontalAlign="center" styles={{ root: { height: '100vh' } }}>
        <Spinner size={SpinnerSize.large} label="Redirecting to login..." />
      </Stack>
    )
  }

  // Set token getter synchronously before rendering children
  setTokenGetter(getAccessToken)

  if (!isCemEmployee(user)) {
    return <Unauthorized />
  }

  return <>{children}</>
}

export default ProtectedRoute
